import Base from '../../js/_base';
import bootstrapBreakpoints from '../../plugins/grid';
let $document;

export default class TableAccordion extends Base {
    tableVPort;

    get selectors() {
        return {
            btnTableExpandRow: '.table-expand-row',
            collapse: '.collapse',
        };
    }

    get elements() {
        return {
            btnsTableExpandRow: null,
            collapsableElements: null,
        };
    }

    get classList() {
        return {
            displayNone: 'd-none',
            show: 'show',
            collapsed: 'collapsed',
        };
    }

    constructor(wrapper) {
        super();
        this.wrapper = wrapper;
        $document = $(document);
        this.initialize();
    }

    initialize() {
        super.initialize();
        this.tableVPort = this.wrapper?.dataset?.vport;
        this.setElements();
        this.currentViewPort();
        this.addEventListeners();
    }

    setElements() {
        this._elements.btnsTableExpandRow = this.wrapper.querySelectorAll(this._selectors.btnTableExpandRow);
        if (this.tableVPort) {
            this._elements.collapsableElements = this.wrapper.querySelectorAll(this._selectors.collapse);
        }
    }

    addEventListeners() {
        super.addEventListeners();
        this.setViewPortListener();
    }

    currentViewPort() {
        // Account for on page first load viewport state
        if (this.tableVPort) {
            let breakpoint = this.tableVPort.split('-').pop();
            if (!breakpoint || (breakpoint && window.outerWidth < bootstrapBreakpoints[breakpoint])) {
                this.onViewPort();
                return;
            }
        }
        this.offViewPort();
    }

    setViewPortListener() {
        $document
            .on(this.tableVPort + '-on', this.onViewPort.bind(this))
            .on(this.tableVPort + '-off', this.offViewPort.bind(this));
    }

    onViewPort() {
        this._elements.btnsTableExpandRow?.forEach(row => {
            row.classList.remove(this._classList.displayNone);
        });
        this._elements.collapsableElements?.forEach(el => {
            el.classList.remove(this._classList.show);
        });
    }

    offViewPort() {
        this._elements.btnsTableExpandRow?.forEach(row => {
            row.classList.add(this._classList.displayNone);
            if (!row.classList.contains(this._classList.collapsed)) {
                row.click();
            }
        });
        this._elements.collapsableElements?.forEach(el => {
            el.classList.add(this._classList.show);
        });
    }
}
